import { useEffect, useRef, useState } from "react";
import logoFireOn from "../../images/logo_fireOn.png";
import { Link, useNavigate } from "react-router-dom";
import { apiWrapper } from "apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { useAppContext } from "utils/store";
import {
  getStatusColorClassName,
  getStatusClassName,
  getStatusName,
  FirefightingObjectFilterType,
  getFirefightingObjectFilterTypeName,
  getFirefightingObjectOrderTypeName,
  FirefightingObjectOrderType,
  getFirefightingObjectOrderType,
  getStatusImage,
} from "utils/common";
import { getDateTime } from "utils/date";
import { connectRealtimeFireStatusWebSocket } from "websock/realtimeFireStatusManager";

export default function FireOnListComponent(props) {
  const {
    store: { id },
  } = useAppContext();
  const [dataSource, setDataSource] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterType, setFilterType] = useState("1");
  const [filterValue, setFilterValue] = useState("");
  const [orderType, setOrderType] = useState("name_asc");

  useEffect(() => {
    connectRealtimeFireStatusWebSocket(id, (data) => {
      const runStatusList = data.runStatusList;

      setDataSource((prevData) =>
        prevData.map((item) => {
          if (runStatusList[item.id] !== undefined) {
            return { ...item, status: runStatusList[item.id] };
          }
          return item;
        })
      );
    });

    getData(filterType, filterValue, orderType);
  }, []);

  const getData = (filterType, filterValue, orderType) => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingObjectList(
        filterType,
        filterValue,
        orderType
      );
      if (status === true) {
        setDataSource(data);

        if (data.length === 0) {
          setIsModalOpen(true);
          setTimeout(() => {
            setIsModalOpen(false);
          }, 3000);
        }
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleChangeFilterType = (filterType) => {
    setFilterType(filterType);
  };

  const handleChangeFilterValue = (filterValue) => {
    setFilterValue(filterValue);
  };

  const handleChangeOrderType = (orderType) => {
    setOrderType(orderType);

    getData(filterType, filterValue, orderType);
  };

  return (
    <>
      <div className="viewBoard fireOnBoard">
        <TopBoard header={props.header} />
        <MidBoard
          getData={getData}
          handleChangeFilterType={handleChangeFilterType}
          handleChangeFilterValue={handleChangeFilterValue}
          orderType={orderType}
        />
        <StateBoard
          dataSource={dataSource}
          handleChangeOrderType={handleChangeOrderType}
        />
        {isModalOpen && (
          <div className="modal-overlay show" id="modalOverlay">
            <div class="modal-content infoResultModal ">
              <div class="modal_inner">
                <p class="title_cont">조회 결과가 없습니다.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

const TopBoard = ({ header }) => {
  return (
    <>
      <div className="top_board pc">
        <div className="img_logo">
          <img src={logoFireOn} alt="fire-on" />
        </div>
        {header}
      </div>
      <div className="top_board mb">
        <div className="wrap_logo"></div>
        <div className="header_dept">
          <p className="user">COWORKER</p>
          <div className="wrap_contr">
            <Link className="set_contr" to="">
              <img src="/images/my_btn_mb_w.png" alt="" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

const MidBoard = ({
  getData,
  handleChangeFilterType,
  handleChangeFilterValue,
  orderType,
}) => {
  const searchTextRef = useRef(null);
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("2");

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedSearchType(type);
    handleChangeFilterType(type);

    setIsSearchListOpen(false);
  };

  const handleChangeSearchText = (e) => {
    if (e.keyCode === 13) {
      handleSearch(e);
    }
  };

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      if (searchTextRef.current.value === "") {
        getData("1", "", orderType);
      } else {
        handleChangeFilterValue(searchTextRef.current.value);
        getData(selectedSearchType, searchTextRef.current.value, orderType);
      }
    }
  };

  return (
    <>
      <div className="mid_board main-mid-board">
        <div className="wrap_tag sc-item">
          {isSearchBoxOpen === true ? (
            <div className="wrap_search pc openSearch">
              <div className="box_search">
                <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                  <button className="btn_select" onClick={toggleSelectBox}>
                    <p>
                      {getFirefightingObjectFilterTypeName(selectedSearchType)}
                    </p>
                    <i className="x-icon"></i>
                  </button>
                  <ul className="list_member">
                    {Object.values(FirefightingObjectFilterType).map(
                      (item, index) => {
                        if (item !== FirefightingObjectFilterType.ALL) {
                          return (
                            <li
                              key={index}
                              onClick={() => handleSearchItemClick(item)}
                            >
                              <p>{getFirefightingObjectFilterTypeName(item)}</p>
                            </li>
                          );
                        }
                      }
                    )}
                  </ul>
                </div>
                <input
                  ref={searchTextRef}
                  type="text"
                  placeholder="검색어를 입력해주세요."
                  onChange={handleChangeSearchText}
                  onKeyDown={handleSearch}
                />
                <button className="btn_search" onClick={handleSearch}>
                  <i className="x-icon icon_search"></i>
                </button>
                <button
                  className="btn_search"
                  onClick={() => setIsSearchBoxOpen(false)}
                >
                  <i className="x-icon icon_search"></i>
                </button>
              </div>
            </div>
          ) : (
            <div className="wrap_item_contr pc">
              <button
                className="btn_contr btn_add"
                onClick={() => setIsSearchBoxOpen(true)}
              >
                검색
                <i className="x-icon"></i>
              </button>
            </div>
          )}
        </div>
        <div className="wrap_right wrap_main-right">
          <div className="wrap_item_contr pc">
            <Link className="btn_contr btn_add" to="/fire-on/add">
              추가
              <i className="x-icon"></i>
            </Link>
            <Link className="btn_contr btn_new" to="/fire-on/new">
              신규 등록
              <i className="x-icon"></i>
            </Link>
            <Link className="btn_contr btn_del" to="/fire-on/delete">
              삭제
              <i className="x-icon"></i>
            </Link>
          </div>
          <Link className="btn_page_left mb" to="/fireOn_mb.html">
            <i className="x-icon"></i>
          </Link>
        </div>
      </div>
    </>
  );
};

const StateBoard = ({ dataSource, handleChangeOrderType }) => {
  const [checkedItem, setCheckedItem] = useState(null);
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState("0");

  const handleChangeCheck = (item) => {
    if (checkedItem && checkedItem.id === item.id) {
      setCheckedItem(null);
    } else {
      setCheckedItem(item);
    }
  };

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedOrderType(type);
    handleChangeOrderType(getFirefightingObjectOrderType(type));

    setIsSearchListOpen(false);
  };

  return (
    <div className="stateBoard stateTileBoard">
      {checkedItem && (
        <div className="toolbar" style={{ display: "block" }}>
          <div className="wrap_inner">
            <Link
              className="btn_tb btn_tb"
              to={`/fire-on/new/${checkedItem.id}`}
              state={{ buildingName: checkedItem.buildingName }}
            >
              대상물 정보
            </Link>
            <Link
              className="btn_tb btn_tbDate"
              to={`/fire-on/fire-inspection-schedule/${checkedItem.id}`}
              state={{
                buildingName: checkedItem.buildingName,
                serialNumber: checkedItem.serialNumber,
                dei: checkedItem.dei,
              }}
            >
              소방점검관리
            </Link>
            <Link
              className="btn_tb btn_tbAlaram"
              to={`/fire-on/alarm-settings/${checkedItem.id}`}
              state={{
                buildingName: checkedItem.buildingName,
                serialNumber: checkedItem.serialNumber,
                dei: checkedItem.dei,
              }}
            >
              경보음 설정
            </Link>
          </div>
        </div>
      )}
      <div className="wrap_state_current">
        <div className="all_current">
          전체
          <p className="all_num">{dataSource ? dataSource.length : 0}</p>
          개소
        </div>
        <div className="order_type">
          <div className="wrap_search pc openSearch">
            <div className="box_search">
              <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                <button className="btn_select" onClick={toggleSelectBox}>
                  <p>{getFirefightingObjectOrderTypeName(selectedOrderType)}</p>
                  <i className="x-icon"></i>
                </button>
                <ul className="list_member">
                  {Object.values(FirefightingObjectOrderType).map(
                    (item, index) => (
                      <li
                        key={index}
                        onClick={() => handleSearchItemClick(item)}
                      >
                        <p>{getFirefightingObjectOrderTypeName(item)}</p>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrap_state">
        {/* ✅ 클래스명에 따라 상태 색상과 이름이 변경됩니다. 
                정상    : status-normal  
                통신장애 : status-comm-error
                화재감지 : status-fire-detected
                소방점검 : status-maintenance */}
        {dataSource &&
          dataSource.length > 0 &&
          dataSource.map((item, index) => (
            <ItemState
              item={item}
              checkedItem={checkedItem}
              handleChangeCheck={handleChangeCheck}
            />
          ))}
      </div>
    </div>
  );
};

const ItemState = ({ item, checkedItem, handleChangeCheck }) => {
  //PC 판별
  const isPC = () => {
    return !/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  const handleItemStateDoubleClick = (item) => {
    window.open(`/fire-on/alarm-monitor/${item.id}`, "_blank");
  };

  return (
    <div
      className={`item_state ${getStatusClassName(item.status)} ${checkedItem && item.id === checkedItem.id ? "chkItem" : ""
        } `}
      onClick={() => handleChangeCheck(item)}
      onDoubleClick={() => {
        if (isPC()) {
          handleItemStateDoubleClick(item);
        }
      }}
    >
      <div className={`item-status-img ${getStatusClassName(item.status)}`}>
        <img src={getStatusImage(item.status)} alt="fire-on" />
      </div>
      <div className="wrap_title_item">
        <p className="title_item">{item.buildingName}</p>
        <div className="adr_item">
          <p className="serial_Code">{item.serialNumber}</p>
          <span className="bar"></span>
          <p className="text_adr">{`${item.roadAddress} ${item.roadAddressDetail}`}</p>
        </div>
      </div>
      <div className="wrap_state_item">
        <div
          className={`cir_state ${getStatusColorClassName(item.status)}`}
        ></div>
        <p className="title_state">{getStatusName(item.status)}</p>
      </div>
    </div>
  );
};
